import { Dispatch } from '@reduxjs/toolkit';
import { setRegions } from '../actions';
import { AppState } from '../store';

export function getRegions(): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const data = await fetch(`${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/Geography/regions`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const regions = await data.json();
      dispatch(setRegions(regions));
    } catch (error) {
      console.error(error);
    }
  };
}
